import React, { useEffect, useState } from 'react'

export default function EditMeetingModal({meeting, onClose, onSaved}){
  const [membersList, setMembersList] = useState([])
  const [rolesList, setRolesList] = useState([])
  const [local, setLocal] = useState(null)
  const [saving, setSaving] = useState(false)

  useEffect(()=>{
    if(meeting){
      // deep copy to avoid mutating parent
      setLocal(JSON.parse(JSON.stringify(meeting)))
      fetch('/api/members').then(r=>r.json()).then(setMembersList)
      fetch('/api/admin/roles').then(r=>r.json()).then(setRolesList)
    }
  }, [meeting])

  if(!meeting || !local) return null

  function updateField(key, val){ setLocal(prev=> ({...prev, [key]: val})) }

  function configuredPoints(role){
    const configuredRole = rolesList.find(item => item.name === role)
    return configuredRole ? Number(configuredRole.points) : 1
  }

  function updateLedgerRow(idx, changes){
    setLocal(prev=>{
      const copy = JSON.parse(JSON.stringify(prev))
      copy.ledger[idx] = { ...copy.ledger[idx], ...changes }
      return copy
    })
  }

  function addMemberRow(){
    setLocal(prev=>{
      const copy = JSON.parse(JSON.stringify(prev))
      copy.ledger = copy.ledger || []
      const defaultRole = rolesList.find(role => role.name === 'Attendance Only') || rolesList[0] || { name: 'Attendance Only', points: 1 }
      copy.ledger.push({ attendee_type: 'Member', member_id: '', role: defaultRole.name, points_awarded: Number(defaultRole.points) })
      return copy
    })
  }
  function addGuestRow(){
    setLocal(prev=>{
      const copy = JSON.parse(JSON.stringify(prev))
      copy.ledger = copy.ledger || []
      copy.ledger.push({ attendee_type: 'Guest', name_override: '' })
      return copy
    })
  }
  function removeRow(idx){
    setLocal(prev=>{
      const copy = JSON.parse(JSON.stringify(prev) || '{}')
      copy.ledger = copy.ledger || []
      copy.ledger.splice(idx,1)
      return copy
    })
  }

  async function save(){
    if(!local) return
    console.debug('save() start', local)
    setSaving(true)
    const payload = { meeting_no: local.meeting_no, meeting_date: local.meeting_date, theme: local.theme, venue: local.venue, club_name: local.club_name, mom_text: local.mom_text, members: [], guests: [] };
    (local.ledger||[]).forEach(l=>{
      console.debug('processing ledger row', l)
      if(l.attendee_type==='Member'){
        const mid = l.member_id ? (isNaN(Number(l.member_id)) ? l.member_id : Number(l.member_id)) : null
        payload.members.push({ member_id: mid, role: l.role })
      } else {
        payload.guests.push({ name: l.name_override || '' })
      }
    })
    console.debug('payload assembled', payload)
    try{
      const id = local.id || (meeting && meeting.id)
      if(!id) throw new Error('Missing meeting id')
      console.debug('about to fetch, id=', id)
      const res = await fetch('/api/meetings/'+id, { method: 'PUT', headers: {'Content-Type':'application/json'}, body: JSON.stringify(payload) })
      const txt = await res.text()
      console.debug('fetch returned', res.status, txt)
      if(res.ok){
        try{ if(typeof onSaved === 'function') onSaved() }catch(e){}
        try{ if(typeof onClose === 'function') onClose() }catch(e){}
      } else {
        alert('Error: '+txt)
      }
    }catch(e){ alert('Save failed: '+e) }
    finally{ setSaving(false) }
  }

  return (
    <div style={{position:'fixed',left:0,top:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:9999}}>
      <div style={{background:'#fff',padding:20,borderRadius:8,width:'95%',maxWidth:980,maxHeight:'90%',overflow:'auto'}}>
        <h3>Edit Report</h3>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8}}>
          <label>Meeting No<input value={local.meeting_no||''} onChange={e=>updateField('meeting_no', e.target.value)} /></label>
          <label>Meeting Date<input type="date" value={local.meeting_date||''} onChange={e=>updateField('meeting_date', e.target.value)} /></label>
        </div>
        <div style={{marginTop:8}}>
          <label>Club Name<input value={local.club_name||''} onChange={e=>updateField('club_name', e.target.value)} /></label>
        </div>
        <div style={{marginTop:12}}>
          <h4>Attendees</h4>
          {(local.ledger||[]).map((l, idx) => l.attendee_type === 'Member' && (
            <div key={idx} style={{display:'flex',gap:8,marginBottom:6,alignItems:'center'}}>
              <select value={l.member_id||''} onChange={e=>updateLedgerRow(idx, { member_id: e.target.value })} style={{flex:2}}>
                <option value="">-- select member --</option>
                {membersList.map(m=> <option key={m.id} value={m.id}>{m.name}</option>)}
              </select>
              <select value={l.role||''} onChange={e=>updateLedgerRow(idx, { role: e.target.value, points_awarded: configuredPoints(e.target.value) })} style={{flex:2}}>
                {rolesList.map(r=> <option key={r.id} value={r.name}>{r.name}</option>)}
              </select>
              <div style={{width:80}}>{configuredPoints(l.role)}pt</div>
              <button className="secondary" onClick={()=>removeRow(idx)}>Remove</button>
            </div>
          ))}
          <button className="primary" onClick={addMemberRow} style={{marginTop:2}}>+ Add Member</button>

          <div style={{marginTop:16}}>
            <h4>Guests</h4>
            {(local.ledger||[]).map((l, idx) => l.attendee_type === 'Guest' && (
              <div key={idx} style={{display:'flex',gap:8,marginBottom:6,alignItems:'center'}}>
                <input placeholder='Guest name' value={l.name_override||''} onChange={e=>updateLedgerRow(idx, { name_override: e.target.value })} style={{flex:2}} />
                <button className="secondary" onClick={()=>removeRow(idx)}>Remove</button>
              </div>
            ))}
            <button className="primary" onClick={addGuestRow} style={{marginTop:2}}>+ Add Guest</button>
          </div>
        </div>
        <div style={{marginTop:12}}>
          <label>Minutes / MoM</label>
          <textarea value={local.mom_text||''} onChange={e=>updateField('mom_text', e.target.value)} style={{width:'100%',minHeight:100}} />
        </div>
        <div style={{textAlign:'right', marginTop:12}}>
          <button className="secondary" onClick={(e)=>{console.debug('click onClose', typeof onClose); if(typeof onClose==='function') onClose()}} style={{marginRight:8}} disabled={saving}>Close</button>
          <button className="primary" onClick={(e)=>{console.debug('click save', typeof save); save()}} disabled={saving}>{saving? 'Saving...':'Save'}</button>
        </div>
      </div>
    </div>
  )
}
